import reduxCrud from 'redux-crud';

const stopsActionCreators = reduxCrud.actionCreatorsFor('stops', {
  key: 'id',
});
const actionTypes = reduxCrud.actionTypesFor('stops', { key: 'id' });

export default stopsActionCreators;
export { actionTypes };
